{"version":"2.96.0","build":"20261105-1","hash":"b7bbcfbeed3fc46411b5b37cdf95c1116aec9e8c","isDirty":false}